import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

export const AdminGuard: CanActivateFn = async () => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  const userId = auth.getUserInformations();
  if (!userId) {
    await router.navigate(['/login']);
    return false;
  }

  const cachedLevel = sessionStorage.getItem('_ui_pref_t');

  // Explicitamente marcado como não-admin → bloqueia sem HTTP
  if (cachedLevel !== null && cachedLevel !== 'x2r') {
    await router.navigate(['/my-garage']);
    return false;
  }

  // Admin confirmado em cache → passa imediatamente
  // Não cacheado ainda → deixa entrar; AdminComponent verifica e mostra loading
  return true;
};
